import React, { useEffect, useState } from 'react'
import { darken } from '@material-ui/core/styles/colorManipulator'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { useDispatch } from 'react-redux'
import * as UserActions from 'app/auth/store/actions/user.actions.js'
import { activatePlaceAndGetPlaceProfileAndUserProfileAPI } from 'app/auth/authAPI'
import { Typography, CircularProgress, Divider } from '@material-ui/core'
import Assets from 'app/configs/assetConfigs'
import { FormattedMessage } from 'react-intl'
import CommonBackground from 'app/components/CommonBackground'
import ContainerNotifyMeCard from 'app/components/ContainerNotifyMeCard'
import AuthenticateCardFooter from 'app/components/AuthenticateCardFooter'
import { useBreakpoints } from 'commons/useBreakpoints'

const useStyles = makeStyles((theme) => ({
  root: {
    background:
      'linear-gradient(to bottom, ' +
      theme.palette.primary.dark +
      ' 0%, ' +
      darken(theme.palette.primary.dark, 0.5) +
      ' 100%)',
  },
  registerHero: {
    'background-color': theme.palette.register.darkBackground,
    '& p': {
      color: theme.palette.register.contrastText,
    },
  },
  logoImage: {
    height: '120px',
  },
  melon: {
    color: '#f74872',
  },
  linkColor: {
    color: `${theme.palette.textHighlight} !important`,
  },
  darkGreyBlueText: {
    color: theme.palette.darkGreyBlue.main,
  },
  responsiveSize: {
    [useBreakpoints(theme).lessThan.md]: {
      maxWidth: '305px',
    },
  },
  responsiveProgressText: {
    [useBreakpoints(theme).lessThan.sm]: {
      maxWidth: '250px',
    },
  },
}))

export default (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [showEror, setshowEror] = useState(false)
  const getToken = () => {
    return props.match.params.token
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const token = getToken()
    if (token == null) {
      setshowEror(true)
      return
    }
    activatePlaceAndGetPlaceProfileAndUserProfileAPI(token)
      .then(({ user, token, place, awsCredential }) => {
        dispatch(
          UserActions.setUserDataByUserAPI(user, token, place, awsCredential),
        )
      })
      .catch((error) => {
        setshowEror(true)
      })
  }, [activatePlaceAndGetPlaceProfileAndUserProfileAPI])
  /* eslint-enable react-hooks/exhaustive-deps */

  const getErrorSection = () => {
    return (
      <div className="flex flex-col px-16 py-32 items-center">
        <img
          alt="App Logo"
          src={Assets.redMailWithCircleBgIcon}
          className={clsx(classes.logoImage, 'p-12', 'h-128')}
        />
        <Typography
          variant="h5"
          gutterBottom
          className={clsx(
            classes.responsiveSize,
            classes.melon,
            'py-24 text-center',
          )}
        >
          <FormattedMessage
            id="verifyingRegistration.failure.title"
            values={{
              b: (text) => <b>{text}</b>,
            }}
          ></FormattedMessage>
        </Typography>
        <Divider
          className={clsx(
            classes.responsiveSize,
            'flex self-center mx-16 mb-32 w-11/12 xs:w-11/12 sm:w-11/12 md:w-1/2  md:hidden lg:hidden xl:hidden',
          )}
        />
        <AuthenticateCardFooter />
      </div>
    )
  }

  const getProgressSection = () => {
    return (
      <div className="flex flex-col pb-32 pt-56 pb-0 items-center">
        <CircularProgress
          className="mx-auto mb-32"
          color="secondary"
        ></CircularProgress>
        <Typography
          variant="h5"
          className={clsx(
            classes.responsiveProgressText,
            classes.darkGreyBlueText,
            'py-24 text-center',
          )}
        >
          <FormattedMessage id="verifyingRegistration.title"></FormattedMessage>
        </Typography>
      </div>
    )
  }

  return (
    <CommonBackground>
      <ContainerNotifyMeCard>
        {showEror ? getErrorSection() : getProgressSection()}
      </ContainerNotifyMeCard>
    </CommonBackground>
  )
}
